export default {"src":"/_next/static/media/ico-search-bk.2897bd0a.svg","height":12,"width":12};